<template>
    <div>
      <loading :active.sync="loader.isLoading" :can-cancel="loader.canCancel" :is-full-page="loader.fullPage" :color="loader.color" :height="loader.height" :width="loader.width" :background-color="loader.backgroundColor" :loader="loader.loader"></loading>
      <div class="row">
          <div class="col-md-12">
              <div class="top-list-small-toolbar-xl">
                  <div>
                      <h4 class="text-primary">Piutang Salesman New</h4>
                      <hr>
                      <div class="row">
                        <div class="col-md-4">
                          <dl class="row">
                            <dt class="col-md-4">Company</dt>
                            <dd class="col-md-8">
                              <select v-model="company_no" class="form-control">
                                <option value="">-- All --</option>
                                <option v-for="c in companyList" :key="c.id" :value="c.company_no">{{ c.name }}</option>
                              </select>
                            </dd>
                            <dt class="col-md-4">Salesman:</dt>
                            <dd class="col-md-8">
                              <v-select :options="getUserSalesman" :reduce="salesman => salesman.meta.code" label="salesman" v-model="salesman_id" class="vsc-custom vsc-custom-inline"/>
                            </dd>
                            <dt class="col-md-4">&nbsp;</dt>
                            <dd class="col-md-8">
                              <button type="button" class="btn btn-sm  btn-hard-primary" @click="refreshList"><i class="fa fa-refresh" aria-hidden="true"></i> Refresh</button>
                              <button class="btn btn-warning btn-sm dropdown-toggle" type="button" id="printsales" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><i class="fa fa-print" aria-hidden="true"></i> Print</button>
                              <div class="dropdown-menu" aria-labelledby="printsales">
                                <a class="dropdown-item" href="javascript:void(0)" @click="print('regular')">Print Piutang</a>
                                <a class="dropdown-item" href="javascript:void(0)" @click="print('salesman')">Print Piutang untuk salesman</a>
                                <a class="dropdown-item" href="javascript:void(0)" @click="print('excel')">Print Piutang Excel</a>
                              </div>
                            </dd>
                          </dl>
                        </div>
                        <div class="col-md-4">
                          <dl class="row">
                            <dt class="col-md-4">Area:</dt>
                            <dd class="col-md-8">
                              <select v-model="area" class="form-control">
                                <option value="">-- All --</option>
                                <option v-for="a in areaList" :key="a.id" :value="a.name">{{ a.name }}</option>
                              </select>
                            </dd>
                            <dt class="col-md-4">Status</dt>
                            <dd class="col-md-8">
                              <select v-model="status" class="form-control">
                                <option value="all">All</option>
                                <option value="outstanding">Piutang</option>
                              </select>
                            </dd>
                          </dl>
                        </div>
                        <div class="col-md-4">
                          <dl class="row">
                            <dt class="col-md-4">Begin:</dt>
                            <dd class="col-md-8">
                              <datetime v-model="date" format="dd/MM/yyyy" class="form-control form-control-lite" value-zone="local" zone="local" ></datetime>
                            </dd>
                            <dt class="col-md-4">End:</dt>
                            <dd class="col-md-8">
                              <datetime v-model="date2" format="dd/MM/yyyy" class="form-control form-control-lite" value-zone="local" zone="local" ></datetime>
                            </dd>
                            <dt class="col-md-4">Term:</dt>
                            <dd class="col-md-8">
                              <select v-model="term" class="form-control">
                                <option value="0">-- no term --</option>
                                <option value="18">> 18 day</option>
                                <option value="21">> 21 day</option>
                                <option value="30">> 30 day</option>
                                <option value="40">> 40 day</option>
                                <option value="48">> 48 day</option>
                                <option value="58">> 58 day</option>
                                <option value="94">> 94 day</option>
                                <option value="titipan">Titipan</option>
                              </select>
                            </dd>
                            <dt class="col-md-4"></dt>
                            <dd class="col-md-8">
                              <div class="custom-control custom-checkbox">
                                <input type="checkbox" id="canBarcode" data-parsley-multiple="groups" data-parsley-mincheck="2" class="custom-control-input" v-model="includeTitipan">
                                <label for="canBarcode" class="custom-control-label">Include Titipan</label>
                              </div>
                            </dd>
                          </dl>
                        </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
      <div class="row" style="margin-top: 250px">
        <div class="col-md-3">
          <div class="card report-card">
            <div class="card-body">
              <div class="float-right">
                <i class="dripicons-user-group report-main-icon"></i>
              </div>
              <h5><span class="badge badge-success">Total Sales</span></h5>
              <h3 class="my-3">
                <span>{{ totalSales | currency }}</span>
              </h3>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="card report-card">
            <div class="card-body">
              <div class="float-right">
                <i class="dripicons-user-group report-main-icon"></i>
              </div>
              <h5><span class="badge badge-warning">Total Retur</span></h5>
              <h3 class="my-3">
                <span>{{ totalRetur | currency }}</span>
              </h3>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="card report-card">
            <div class="card-body">
              <div class="float-right">
                <i class="dripicons-user-group report-main-icon"></i>
              </div>
              <h5><span class="badge badge-primary">Total Payment</span></h5>
              <h3 class="my-3">
                <span>{{ totalPayment | currency }}</span>
              </h3>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="card report-card">
            <div class="card-body">
              <div class="float-right">
                <i class="dripicons-user-group report-main-icon"></i>
              </div>
              <h5><span class="badge badge-warning">Total Outstanding</span></h5>
              <h3 class="my-3">
                <span>{{ totalOutstanding | currency }}</span>
              </h3>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="card report-card">
            <div class="card-body">
              <div class="float-right">
                <i class="dripicons-user-group report-main-icon"></i>
              </div>
              <h5><span class="badge badge-warning">Total Outstanding Giro</span></h5>
              <h3 class="my-3">
                <span>{{ totalOutstandingGiro | currency }}</span>
              </h3>
            </div>
            <!--end card-body-->
          </div>
          <!--end card-->
        </div>
        <div class="col-md-3">
          <div class="card report-card">
            <div class="card-body">
              <div class="float-right">
                <i class="dripicons-user-group report-main-icon"></i>
              </div>
              <h5><span class="badge badge-success">Total Sales Month</span></h5>
              <h3 class="my-3">
                <span>{{ totalSaleMonth | currency }}</span>
              </h3>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="card report-card">
            <div class="card-body">
              <div class="float-right">
                <i class="dripicons-user-group report-main-icon"></i>
              </div>
              <h5><span class="badge badge-success">Total Payment Month</span></h5>
              <h3 class="my-3">
                <span>{{ totalPaymentMonth | currency }}</span>
              </h3>
            </div>
          </div>
        </div>
        <div class="col-md-3">
          <div class="card report-card">
            <div class="card-body">
              <div class="float-right">
                <i class="dripicons-user-group report-main-icon"></i>
              </div>
              <h5><span class="badge badge-success">Total Retur Month</span></h5>
              <h3 class="my-3">
                <span>{{ totalReturMonth | currency }}</span>
              </h3>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-body">
              <ul class="nav nav-tabs nav-bordered">
                <li class="nav-item"><a href="#data-sort" data-toggle="tab" aria-expanded="false" class="nav-link active">Data Sort</a></li>
                <li class="nav-item"><a href="#data-raw" data-toggle="tab" aria-expanded="false" class="nav-link">Raw</a></li>
                <li class="nav-item"><a href="#data-sales" data-toggle="tab" aria-expanded="false" class="nav-link">Sales</a></li>
                <li class="nav-item"><a href="#data-retur" data-toggle="tab" aria-expanded="false" class="nav-link">Retur</a></li>
                <li class="nav-item"><a href="#data-payment" data-toggle="tab" aria-expanded="false" class="nav-link">Payment</a></li>
                <li class="nav-item"><a href="#rekap-piutang" data-toggle="tab" aria-expanded="false" class="nav-link">Rekap</a></li>
                <li class="nav-item"><a href="#error" data-toggle="tab" aria-expanded="false" class="nav-link">Error Check</a></li>
              </ul>
              <div class="tab-content">
                <div class="tab-pane active" id="data-sort">
                  <div class="table-responsive">
                      <div v-for="i in dataRaw" :key="i.id">
                          <div v-for="a in i.area" :key="a.name">
                              <h5 style="margin-top: 25px" class="text-center"><b>{{ i.salesman_id }}</b> - {{ i.salesman }}</h5>
                              <h5 class="text-center">{{ a.name }} ({{ a.outstanding | currency}}) payment: {{ a.total_payment | currency }}</h5>
                              <table class="table table-item mb-0 table-sm table-striped table-hover">
                                  <thead>
                                      <th>Sales No.</th>
                                      <th>Customer</th>
                                      <th>Area</th>
                                      <th>Sale Date</th>
                                      <th>Due Date</th>
                                      <th>Age</th>
                                      <th class="text-right">Retur</th>
                                      <th class="text-right">Total</th>
                                      <th class="text-right">Payment</th>
                                      <th class="text-right">Outstanding</th>
                                      <th class="text-right">Outstanding Giro</th>
                                  </thead>
                                  <tbody>
                                      <tr v-for="s in a.saleColl" :key="s.id">
                                          <td><span class="text-ref-sales" @click="showSaleNo(s.sale_no)" data-toggle="modal" data-target="#modalSalesByNo" data-backdrop="static" data-keyboard="false">{{ s.sale_no }}</span></td>
                                          <td>
                                            {{ s.customer }}
                                            <span v-show="s.payment_method === 'Giro'" class="badge badge-info">{{ s.payment_method }}</span>
                                            <span v-show="s.check_tanda_terima === true" class="badge badge-success">Tanda Terima</span>
                                          </td>
                                          <td>{{ s.area }}</td>
                                          <td>{{ s.sale_date | dateFormat('DD/MM/YYYY') }}</td>
                                          <td>{{ s.sale_due_date | dateFormat('DD/MM/YYYY') }}</td>
                                          <td>{{ s.age }}</td>
                                          <td class="text-right">{{ s.retur_total | currency }}</td>
                                          <td class="text-right">{{ s.total | currency }}</td>
                                          <td class="text-right">{{ s.payment_balance | currency }}</td>
                                          <td class="text-right">{{ s.outstanding | currency }}</td>
                                          <td class="text-right">{{ s.outstanding_giro | currency }}</td>
                                      </tr>
                                  </tbody>
                                  <tfoot>
                                      <tr>
                                          <td></td>
                                          <td></td>
                                          <td></td>
                                          <td></td>
                                          <td></td>
                                          <td></td>
                                          <td></td>
                                          <td class="text-right"><b>{{ a.total | currency }}</b></td>
                                          <td class="text-right"><b>{{ a.total_payment | currency }}</b></td>
                                          <td class="text-right"><b>{{ a.outstanding | currency }}</b></td>
                                          <td class="text-right"><b>{{ a.outstanding_giro | currency }}</b></td>
                                      </tr>
                                  </tfoot>
                              </table>
                          </div>
                      </div>
                  </div>
                </div>
                <div class="tab-pane" id="data-raw">
                  <div class="table-responsive">
                    <div v-for="i in dataRaw" :key="i.id">
                          <div v-for="a in i.area" :key="a.name">
                              <h5 style="margin-top: 25px" class="text-center"><b>{{ i.salesman_id }}</b> - {{ i.salesman }}</h5>
                              <h5 class="text-center">{{ a.name }} ({{ a.outstanding | currency}})</h5>
                              <table class="table table-item mb-0 table-sm table-striped table-hover">
                                  <thead>
                                      <th>Type</th>
                                      <th>Sales No.</th>
                                      <th>Customer</th>
                                      <th>Area</th>
                                      <th>Sale Date</th>
                                      <th>Due Date</th>
                                      <th>Age</th>
                                      <th class="text-right">Retur</th>
                                      <th class="text-right">Total</th>
                                      <th class="text-right">Payment</th>
                                      <th class="text-right">Outstanding</th>
                                      <th class="text-right">Outstanding Giro</th>
                                      <th class="text-right">Outstanding Create Date</th>
                                      <th class="text-right">Outstanding Finish Date</th>
                                  </thead>
                                  <tbody>
                                      <tr v-for="(s, sid) in a.sale" :key="sid">
                                          <td>
                                            <select class="form-control form-control-lite" v-model="s.type_id" @change="setTypeSales(s)">
                                              <option v-for="t in salesTypeList" :key="t.id" :value="t.id">{{ t.name }}</option>
                                            </select>
                                            <!-- <pre>{{ s.type_id }}</pre> -->
                                          </td>
                                          <td><span class="text-ref-sales" @click="showSaleNo(s.sale_no)" data-toggle="modal" data-target="#modalSalesByNo" data-backdrop="static" data-keyboard="false">{{ s.sale_no }}</span></td>
                                          <td>{{ s.customer }}  <span v-show="s.payment_method === 'Giro'" class="badge badge-info">{{ s.payment_method }}</span></td>
                                          <td>{{ s.area }}</td>
                                          <td>{{ s.sale_date | dateFormat('DD/MM/YYYY') }}</td>
                                          <td>{{ s.sale_due_date | dateFormat('DD/MM/YYYY') }}</td>
                                          <td>{{ s.age }}</td>
                                          <td class="text-right">{{ s.retur_total | currency }}</td>
                                          <td class="text-right">{{ s.total | currency }}</td>
                                          <td class="text-right">{{ s.payment_balance | currency }}</td>
                                          <td class="text-right">{{ s.outstanding | currency }}</td>
                                          <td class="text-right">{{ s.outstanding_giro | currency }}</td>
                                          <td class="text-right">{{ s.outstanding_create_date | dateFormat('DD/MM/YYYY') }}</td>
                                          <td class="text-right">{{ s.outstanding_date | dateFormat('DD/MM/YYYY') }}</td>
                                      </tr>
                                  </tbody>
                                  <tfoot>
                                      <tr>
                                          <td></td>
                                          <td></td>
                                          <td></td>
                                          <td></td>
                                          <td></td>
                                          <td></td>
                                          <td></td>
                                          <td class="text-right"><b>{{ a.total | currency }}</b></td>
                                          <td class="text-right"><b>{{ a.total_payment | currency }}</b></td>
                                          <td class="text-right"><b>{{ a.outstanding | currency }}</b></td>
                                      </tr>
                                  </tfoot>
                              </table>
                          </div>
                      </div>
                  </div>
                </div>
                <div class="tab-pane" id="data-sales">
                  <div class="row">
                    <div class="col-md-6">
                      <div class="table-responsive">
                        <span>row: {{ dataMonth.length }}</span>
                        <table class="table table-item mb-0 table-sm table-striped table-hover">
                          <thead>
                            <th>Type</th>
                            <th>Sale No.</th>
                            <th>Sale Date</th>
                            <th>Customer</th>
                            <th>Area</th>
                            <th>Retur</th>
                            <th>Total</th>
                            <th>Payment</th>
                          </thead>
                          <tbody>
                            <tr v-for="d in dataMonth" :key="d.id">
                              <td>
                                <select class="form-control form-control-lite" v-model="d.type_id" @change="setTypeSales(d)">
                                  <option v-for="t in salesTypeList" :key="t.id" :value="t.id">{{ t.name }}</option>
                                </select>
                              </td>
                              <td>{{ d.sale_no }}</td>
                              <td>{{ d.sale_date | dateFormat('DD/MM/YYYY') }}</td>
                              <td>{{ d.customer }}</td>
                              <td>{{ d.area }}</td>
                              <td>{{ d.retur_total | currency }}</td>
                              <td>{{ d.total | currency }}</td>
                              <td></td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <div class="col-md-6">
                      <h5>Sales</h5>
                      <div class="table-responsive">
                        <span>row: {{ dataEndDate.length }}</span>
                        <span>Total Sales: {{ totalEndDate | currency }}</span>
                        <table class="table table-item mb-0 table-sm table-striped table-hover">
                          <thead>
                            <th>Sale No.</th>
                            <th>Sale Date</th>
                            <th>Customer</th>
                            <th>Area</th>
                            <th>Retur</th>
                            <th>Total</th>
                            <th>Payment</th>
                          </thead>
                          <tbody>
                            <tr v-for="d in dataEndDate" :key="d.id">
                              <td>{{ d.sale_no }}</td>
                              <td>{{ d.sale_date | dateFormat('DD/MM/YYYY') }}</td>
                              <td>{{ d.customer }}</td>
                              <td>{{ d.area }}</td>
                              <td>{{ d.retur_total | currency }}</td>
                              <td>{{ d.total | currency }}</td>
                              <td>{{ d.payment_balance | currency }}</td>
                            </tr>
                            <tr>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td>{{ totalEndDate | currency }}</td>
                              <td></td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <h5>Payment</h5>
                      <span>{{ totalDataPaymentEndDate | currency }}</span>
                      <span>{{ dataPaymentEndDate.length }}</span>
                      <div class="table-responsive">
                        <table class="table table-item mb-0 table-sm table-striped table-hover">
                          <thead>
                            <th>Sale No</th>
                            <th>Date</th>
                            <th>Payment No.</th>
                            <th class="text-center">Method</th>
                            <th class="text-right">Total</th>
                          </thead>
                          <tbody>
                            <tr v-for="p in dataPaymentEndDate" :key="p.id">
                              <td>{{ p.sale_no }}</td>
                              <td>{{ p.payment_date | dateFormat('DD/MM/YYYY') }}</td>
                              <td>{{ p.group_no }}</td>
                              <td class="text-center">{{ p.method_id }}</td>
                              <td class="text-right">{{ p.price | currency }}</td>
                            </tr>
                            <tr>
                              <td colspan="5">{{ totalDataPaymentEndDate | currency }}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <!-- <pre>{{ dataPaymentEndDate }}</pre> -->
                    </div>
                  </div>
                </div>
                <div class="tab-pane" id="data-retur">
                  <div class="table-responsive">
                    <span>row: {{ dataReturMonth.length }}</span>
                    <table class="table table-item mb-0 table-sm table-striped table-hover">
                      <thead>
                        <th>Return No.</th>
                        <th>Date</th>
                        <th>Total</th>
                      </thead>
                      <tbody>
                        <tr v-for="(r, index) in dataReturMonth" :key="index">
                          <td>{{ r.return_no }}</td>
                          <td>{{ r.return_date | dateFormat('DD/MM/YYYY') }}</td>
                          <td>{{ r.total | currency }}</td>
                        </tr>
                      </tbody>
                    </table>
                    <pre>{{ dataReturMonth }}</pre>
                  </div>
                </div>
                <div class="tab-pane" id="data-payment">
                  <p>Total Payment Group: {{ totalPaymentGroupMonth | currency }} ({{ countPaymentGroupMonth }})</p>
                  <div class="table-responsive">
                    <table class="table table-item mb-0 table-sm table-striped table-hover">
                      <thead>
                        <th></th>
                        <th>Group No.</th>
                        <th>Sale No.</th>
                        <th>Payment Date</th>
                        <th>Finish Date</th>
                        <th class="text-center">Method</th>
                        <th class="text-right">Subtotal</th>
                        <th class="text-right">Discount</th>
                        <th class="text-right">Round</th>
                        <th class="text-right">Denda</th>
                        <th class="text-right">Total</th>
                      </thead>
                      <tbody>
                        <tr v-for="(p, index) in groupDataPaymentGroupMonth" :key="index">
                          <td>
                            <span v-if="p.report_no !== null"><i class="fa fa-check" style="color: green;"></i></span>
                          </td>
                          <td>{{ p.group_no }}</td>
                          <td>{{ p.sale_no }}</td>
                          <td>{{ p.payment_date | dateFormat('DD/MM/YYYY') }}</td>
                          <td>{{ p.finish_date | dateFormat('DD/MM/YYYY') }}</td>
                          <td class="text-center">{{ p.method_id }}</td>
                          <td class="text-right">{{ p.subtotal | currency }}</td>
                          <td class="text-right">{{ p.discount | currency }}</td>
                          <td class="text-right">{{ p.round | currency }}</td>
                          <td class="text-right">{{ p.penalty_amount | currency }}</td>
                          <td class="text-right">{{ p.total | currency }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <div class="tab-pane" id="rekap-piutang">
                  <div class="row justify-content-center">
                  <div class="col-md-8">
                    <div class="table-responsive">
                      <table class="table table-item mb-0 table-sm table-striped table-hover">
                        <tr>
                          <td>Sisa Piutang <i><strong>per - {{ dateRekap | dateFormat('MMMM') }}</strong></i> <button type="button" class="btn btn-sm btn-success" @click="refreshList2">Get</button></td>
                          <td class="text-right">
                            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="rekapLoad"></span>
                            <span v-else><b>{{ totalOutstanding2 | currency }}</b></span>
                          </td>
                        </tr>
                        <tr>
                          <td>Sales (Penjualan)</td>
                          <td class="text-right"><b>{{ totalSaleMonth | currency }}</b></td>
                        </tr>
                        <tr>
                          <td>Retur Jual</td>
                          <td class="text-right"><b>({{ totalReturMonth | currency }})</b></td>
                        </tr>
                        <tr>
                          <td>
                            Penerimaan Pembayaran <i><strong>Gross</strong></i>
                          </td>
                          <td class="text-right"><b>({{ totalPaymentMonth | currency }})</b></td>
                        </tr>
                        <tr>
                          <td><span class="ml-5 font-14"><b>Sisa Piutang</b></span></td>
                          <td class="text-right"><b class="font-14">{{ totalOutstanding2 + totalSaleMonth - totalReturMonth - totalPaymentMonth | currency }}</b></td>
                        </tr>
                      </table>
                    </div>
                  </div>
                </div>
                </div>
                <div class="tab-pane" id="error">
                  <div class="row">
                    <div class="col-md-4">
                      <h5>Data Raw:</h5>
                      <pre>{{ dataRaw }}</pre>
                    </div>
                    <div class="col-md-4">
                      <h5>Data Payment Month:</h5>
                      <pre>{{ dataPaymentMonth }}</pre>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <SaleModal />
    </div>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import { salesUrl, sale2Url, getHeader } from '@/config'
import SaleModal from '@/components/sales/SaleModal.vue'

export default {
  name: 'PiutangSalesman',
  props: ['scroll'],
  components: {
    Loading,
    SaleModal
  },
  data () {
    // var date = new Date()
    // const firstDayYear = new Date(date.getFullYear(), 0, 1)
    return {
      includeTitipan: false,
      rekapLoad: false,
      area: '',
      term: '0',
      salesman_id: '',
      company_no: '',
      year: '2022',
      date: null,
      date2: new Date().toISOString(),
      dateRekap: null,
      typeData: null,
      period: [],
      dataRaw: [],
      dataRaw2: [],
      status: 'all',
      loader: {
        isLoading: false,
        fullPage: true,
        color: '#007bff',
        canCancel: false,
        height: 128,
        width: 128,
        backgroundColor: '#ffffff',
        loader: 'spinner'
      },
      searchQuery: '',
      ascending: true,
      sortClick: false,
      sortColumn: '',
      pageSize: 100,
      currentPage: 1
    }
  },
  mounted () {
    this.$store.dispatch('getSalesTypeList')
    this.$store.dispatch('getCompanyList')
    this.$store.dispatch('getEmployeeList')
    this.$store.dispatch('getAreaList')
  },
  computed: {
    ...mapState({
      rowsTable: state => state.data.rowsTable,
      companyList: state => state.companies.companyList,
      employeeList: state => state.employees.employeeList,
      areaList: state => state.area.areaList,
      salesTypeList: state => state.sales.salesTypeList
    }),
    totalDataSalesRaw () {
      var array = this.dataSalesRaw
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].total)
      }
      return sum
    },
    dataSalesRaw () {
      var loop = []
      var array = this.dataRaw
      for (let i = 0; i < array.length; i++) {
        var area = array[i].area
        for (let a = 0; a < area.length; a++) {
          var sale = area[a].sale
          for (let b = 0; b < sale.length; b++) {
            loop.push(sale[b])
          }
        }
      }
      return loop
    },
    dataMonth () {
      var date = new Date(this.date2)
      var begin = date.getFullYear() + '-' + (date.getMonth() + 1) + '-01'
      console.log('begin: ' + begin)
      var beginTime = new Date(begin).getTime()
      var end = this.date2
      var endTime = new Date(end).getTime()
      console.log(end)
      console.log(endTime)
      var loop = []
      var array = this.dataRaw
      for (let i = 0; i < array.length; i++) {
        var area = array[i].area
        for (let a = 0; a < area.length; a++) {
          var sale = area[a].sale
          for (let b = 0; b < sale.length; b++) {
            var saleDate = sale[b].sale_date
            var saleDateTime = new Date(saleDate).getTime()
            if (saleDateTime >= beginTime) {
              loop.push(sale[b])
            }
          }
        }
      }
      return loop
    },
    dataReturMonth () {
      var date = new Date(this.date2)
      var begin = date.getFullYear() + '-' + (date.getMonth() + 1) + '-01'
      var beginTime = new Date(begin).getTime()
      var end = new Date(this.date2)
      var newEnd = end.getFullYear() + '-' + (end.getMonth() + 1) + '-' + end.getDate() + ' 23:59:59'
      console.log(newEnd)
      var endTime = new Date(newEnd).getTime()
      var loop = []
      var array = this.dataRaw
      for (let i = 0; i < array.length; i++) {
        var area = array[i].area
        for (let a = 0; a < area.length; a++) {
          var sale = area[a].sale
          for (let b = 0; b < sale.length; b++) {
            var retur = sale[b].returns
            for (let c = 0; c < retur.length; c++) {
              var returDate = new Date(retur[c].return_date).getTime()
              if (returDate >= beginTime && returDate <= endTime) {
                loop.push(retur[c])
              }
            }
          }
        }
      }
      return loop
    },
    dataPaymentMonth () {
      var date = new Date(this.date2)
      var begin = date.getFullYear() + '-' + (date.getMonth() + 1) + '-01'
      console.log('begin: ' + begin)
      var beginTime = new Date(begin).getTime()
      var end = this.date2
      var endTime = new Date(end).getTime()
      console.log(end)
      console.log(endTime)
      var loop = []
      var array = this.dataRaw
      for (let i = 0; i < array.length; i++) {
        var area = array[i].area
        for (let a = 0; a < area.length; a++) {
          var sale = area[a].sale
          for (let b = 0; b < sale.length; b++) {
            var pay = sale[b].payment_all
            for (let c = 0; c < pay.length; c++) {
              var paymentDate = new Date(pay[c].payment_date).getTime()
              if (paymentDate >= beginTime && paymentDate <= endTime) {
                loop.push(pay[c])
              }
            }
          }
        }
      }
      const col = 'payment_date'
      const ascending = true
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return loop.sort(function (a, b) {
        if (a[col] > b[col]) {
          return ascending ? 1 : -1
        } else if (a[col] < b[col]) {
          return ascending ? -1 : 1
        }
        return 0
      })
    },
    dataEndDate () {
      var endTime = new Date(this.date2)
      var newEndTime = endTime.getFullYear() + '-' + (endTime.getMonth() + 1) + '-' + endTime.getDate()
      var fixEndTime = new Date(newEndTime).getTime()
      var loop = []
      var array = this.dataRaw
      for (let i = 0; i < array.length; i++) {
        var area = array[i].area
        for (let a = 0; a < area.length; a++) {
          var sale = area[a].sale
          for (let b = 0; b < sale.length; b++) {
            var saleDateTime = new Date(sale[b].sale_date)
            var newSaleDate = saleDateTime.getFullYear() + '-' + (saleDateTime.getMonth() + 1) + '-' + saleDateTime.getDate()
            var fixSaleDate = new Date(newSaleDate).getTime()
            if (fixSaleDate === fixEndTime) {
              loop.push(sale[b])
            } else {
              console.log('time not equal: ' + fixSaleDate + '  ' + fixEndTime)
            }
          }
        }
      }
      return loop
    },
    dataPaymentEndDate () {
      var endTime = new Date(this.date2)
      var newEndTime = endTime.getFullYear() + '-' + (endTime.getMonth() + 1) + '-' + endTime.getDate()
      var fixEndTime = new Date(newEndTime).getTime()
      var loop = []
      var array = this.dataRaw
      for (let i = 0; i < array.length; i++) {
        var area = array[i].area
        for (let a = 0; a < area.length; a++) {
          var sales = area[a].sale
          for (let b = 0; b < sales.length; b++) {
            var payment = sales[b].payment_all
            for (let c = 0; c < payment.length; c++) {
              const pDate = new Date(payment[c].payment_date)
              const formatPdate = pDate.getFullYear() + '-' + (pDate.getMonth() + 1) + '-' + pDate.getDate()
              const paymentDate = new Date(formatPdate).getTime()
              console.log('paymentDate: ' + formatPdate + ' endDate: ' + newEndTime)
              if (paymentDate === fixEndTime) {
                loop.push(payment[c])
              }
            }
          }
        }
      }
      return loop
    },
    totalDataPaymentEndDate () {
      const array = this.dataPaymentEndDate
      let sum = 0
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].price)
      }
      return sum
    },
    totalEndDate () {
      var array = this.dataEndDate
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].total)
      }
      return sum
    },
    dataPaymentGroupMonth () {
      var array = this.dataPaymentMonth
      var loop = []
      for (let i = 0; i < array.length; i++) {
        const group = array[i].group
        if (group) {
          var obj = {
            id: group.id,
            group_no: group.group_no,
            sale_no: array[i].sale_no,
            prepayment_date: group.prepayment_date,
            payment_date: group.payment_date,
            category: group.category,
            total: group.total,
            method_id: group.method_id,
            type_id: group.type_id,
            bank_id: group.bank_id,
            account_code: group.account_code,
            notes: group.notes,
            vendor_no: group.vendor_no,
            customer_no: group.customer_no,
            branch_no: group.branch_no,
            company_no: group.company_no,
            status: group.status,
            lock: group.lock,
            subtotal: group.subtotal,
            round: group.round,
            discount_percentage: group.discount_percentage,
            discount: group.discount,
            finish_date: group.finish_date,
            giro_no: group.giro_no,
            bank_name: group.bank_name,
            report_no: group.report_no,
            ref_no: group.ref_no,
            finish: group.finish,
            penalty_amount: group.penalty_amount
          }
          loop.push(obj)
        }
      }
      return loop
    },
    groupDataPaymentGroupMonth () {
      var result = []
      var data = this.dataPaymentGroupMonth
      if (data.length > 0) {
        data.reduce(function (res, value) {
          // key = Date.parse(value.cost_date) + value.queue + value.company_no
          var key = value.group_no
          if (!res[key]) {
            res[key] = {
              group_no: key,
              sale_no: value.sale_no,
              method_id: value.method_id,
              payment_date: value.payment_date,
              finish_date: value.finish_date,
              subtotal: value.subtotal,
              discount: value.discount,
              tax: value.tax,
              round: value.round,
              penalty_amount: value.penalty_amount == null ? '0' : value.penalty_amount,
              total: value.total,
              report_no: value.report_no
            }
            result.push(res[key])
          }
          return res
        }, {})
      }
      // return result
      var col = 'payment_date'
      var ascending = true
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return result.sort(function (a, b) {
        if (a[col] > b[col]) {
          return ascending ? 1 : -1
        } else if (a[col] < b[col]) {
          return ascending ? -1 : 1
        }
        return 0
      })
    },
    totalPaymentGroupMonth () {
      var date = new Date(this.date2)
      var begin = date.getFullYear() + '-' + (date.getMonth() + 1) + '-01'
      var beginTime = new Date(begin).getTime()
      var array = this.groupDataPaymentGroupMonth
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        const paymentDate = array[i].payment_date
        const paymentDateTime = new Date(paymentDate).getTime()
        if (paymentDateTime >= beginTime) {
          sum += parseFloat(array[i].total)
        }
      }
      return sum
    },
    countPaymentGroupMonth () {
      var date = new Date(this.date2)
      var begin = date.getFullYear() + '-' + (date.getMonth() + 1) + '-01'
      var beginTime = new Date(begin).getTime()
      var array = this.groupDataPaymentGroupMonth
      var count = 0
      for (let i = 0; i < array.length; i++) {
        const paymentDate = array[i].payment_date
        const paymentDateTime = new Date(paymentDate).getTime()
        if (paymentDateTime >= beginTime) {
          count += 1
        }
      }
      return count
    },
    totalSaleMonth () {
      var date = new Date(this.date2)
      var begin = date.getFullYear() + '-' + (date.getMonth() + 1) + '-01'
      var beginTime = new Date(begin).getTime()
      var end = this.date2
      var endTime = new Date(end).getTime()
      console.log(endTime)
      var sum = 0
      var array = this.dataRaw
      for (let i = 0; i < array.length; i++) {
        var area = array[i].area
        for (let a = 0; a < area.length; a++) {
          var sale = area[a].sale
          for (let b = 0; b < sale.length; b++) {
            var saleDate = sale[b].sale_date
            var saleDateTime = new Date(saleDate).getTime()
            if (saleDateTime >= beginTime) {
              sum += parseFloat(sale[b].total)
            }
          }
        }
      }
      return sum
    },
    totalReturMonth () {
      var array = this.dataReturMonth
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].total)
      }
      return sum
    },
    totalPaymentMonth () {
      var array = this.dataPaymentMonth
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].price)
      }
      return sum
    },
    totalPaymentMonthTunai () {
      var array = this.dataPaymentMonth
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        if (array[i].method_id === 1) {
          sum += parseFloat(array[i].price)
        }
      }
      return sum
    },
    totalPaymentMonthTransfer () {
      var array = this.dataPaymentMonth
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        if (array[i].method_id === 2) {
          sum += parseFloat(array[i].price)
        }
      }
      return sum
    },
    totalSales () {
      var sum = 0
      var array = this.dataRaw
      for (let i = 0; i < array.length; i++) {
        var area = array[i].area
        for (let a = 0; a < area.length; a++) {
          sum += parseFloat(area[a].total)
        }
      }
      return sum
    },
    totalOutstanding () {
      var sum = 0
      var array = this.dataRaw
      for (let i = 0; i < array.length; i++) {
        var area = array[i].area
        for (let a = 0; a < area.length; a++) {
          sum += parseFloat(area[a].outstanding)
        }
      }
      return sum
    },
    totalOutstanding2 () {
      var sum = 0
      var array = this.dataRaw2
      for (let i = 0; i < array.length; i++) {
        var area = array[i].area
        for (let a = 0; a < area.length; a++) {
          sum += parseFloat(area[a].outstanding)
        }
      }
      return sum
    },
    totalPayment () {
      var sum = 0
      var array = this.dataRaw
      for (let i = 0; i < array.length; i++) {
        var area = array[i].area
        for (let a = 0; a < area.length; a++) {
          sum += parseFloat(area[a].total_payment)
        }
      }
      return sum
    },
    totalRetur () {
      var sum = 0
      var array = this.dataRaw
      for (let i = 0; i < array.length; i++) {
        var area = array[i].area
        for (let a = 0; a < area.length; a++) {
          var sale = area[a].sale
          for (let b = 0; b < sale.length; b++) {
            sum += parseFloat(sale[b].retur_total)
          }
        }
      }
      return sum
    },
    totalOutstandingGiro () {
      var sum = 0
      var array = this.dataRaw
      for (let i = 0; i < array.length; i++) {
        var area = array[i].area
        for (let a = 0; a < area.length; a++) {
          sum += parseFloat(area[a].outstanding_giro)
        }
      }
      return sum
    },
    getUserSalesman: function () {
      var array = this.employeeList.filter(e => e.position_id === 'H4.1' || e.position_id === 'H4.2' || e.position_id === 'H1' || e.position_id === 'H2')
      var loop = [{
        salesman: '-- All --',
        meta: {
          code: ''
        }
      }]
      for (let a = 0; a < array.length; a++) {
        var obj = {
          salesman: '[' + array[a].employee_no + '] ' + array[a].name,
          meta: {
            code: array[a].employee_no
          }
        }
        loop.push(obj)
      }
      return loop
    },
    pageLength: function () {
      var count = 0
      if (this.searchQuery.length < 0 || this.searchQuery === null) {
        count = this.dataRaw.length
      } else {
        count = this.dataRaw
          .filter(d => {
            for (const name in d) {
              if (d[name] !== null) {
                if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
                  return d
                }
              }
            }
          }).length
      }
      var length = count / this.pageSize

      return Math.ceil(length)
    },
    rowsTotal: function () {
      var count = 0
      if (this.searchQuery.length < 0 || this.searchQuery === null) {
        count = this.dataRaw.length
      } else {
        count = this.dataRaw
          .filter(d => {
            for (const name in d) {
              if (d[name] !== null) {
                if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
                  return d
                }
              }
            }
          }).length
      }
      // console.log(count)
      return count
    },
    filterData: function () {
      if (this.searchQuery.length > 0) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      }
      var col = this.sortColumn
      var ascending = this.ascending
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return this.dataRaw.sort(function (a, b) {
        if (a[col] > b[col]) {
          return ascending ? 1 : -1
        } else if (a[col] < b[col]) {
          return ascending ? -1 : 1
        }
        return 0
      }).filter(d => {
        for (const name in d) {
          if (d[name] !== null) {
            if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
              return d
            }
          }
        }
      }).filter((row, index) => {
        const start = (this.currentPage - 1) * this.pageSize
        const end = this.currentPage * this.pageSize
        if (index >= start && index < end) return true
      })
    }
  },
  methods: {
    async setTypeSales (sale) {
      this.$Progress.start()
      this.loader.isLoading = true
      const body = {
        sale_no: sale.sale_no,
        type_id: sale.type_id
      }
      await axios.post(salesUrl + '/update-type', body, { headers: getHeader() })
        .then(response => {
          console.log(response.data.message)
          this.$Progress.finish()
          this.loader.isLoading = false
        })
        .catch(error => {
          this.$Progress.finish()
          this.loader.isLoading = false
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
    },
    async printSalesman () {
      this.$Progress.start()
      this.loader.isLoading = true
      var data = {
        format: null,
        data: this.dataRaw
      }
      if (data.length === 0) {
        this.$swal('Error', 'Data masih kosong', 'error')
        return false
      }
      console.log(data)
      console.log(sale2Url + '/tagihan-salesman')
      await axios.post(sale2Url + '/tagihan-salesman', data, { responseType: 'blob' })
        .then(response => {
          console.log(response)
          const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', 'Tagihan Salesman.pdf')
          document.body.appendChild(link)
          link.click()
          this.$Progress.finish()
          this.loader.isLoading = false
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
        })
    },
    async print (type) {
      this.$Progress.start()
      this.loader.isLoading = true
      var data = {
        format: type,
        data: this.dataRaw,
        begin: this.date,
        end: this.date2
      }
      if (data.length === 0) {
        this.$swal('Error', 'Data masih kosong', 'error')
        return false
      }
      console.log(data)
      console.log(sale2Url + '/report-outstanding-by-salesman')
      await axios.post(sale2Url + '/report-outstanding-by-salesman', data, { responseType: 'blob' })
        .then(response => {
          const objectUrl = URL.createObjectURL(response.data)
          console.log('Showing PDF...')
          window.open(objectUrl, '_blank')
          this.$Progress.finish()
          this.loader.isLoading = false
        })
        .catch(error => {
          this.$Progress.finish()
          this.loader.isLoading = false
          console.log(error)
          console.log(error.response)
        })
    },
    showSaleNo (no) {
      var payload = {
        sale_no: no
      }
      this.$store.commit('SET_SALE_BY_NO', payload)
      this.$store.dispatch('getSaleByNo', payload)
    },
    setPageSizeOnChange: function () {
      this.currentPage = 1
    },
    sortTable: function sortTable (col) {
      this.currentPage = 1
      if (this.sortColumn === col) {
        this.ascending = !this.ascending
      } else {
        this.ascending = true
        this.sortColumn = col
      }
    },
    nextPage: function () {
      if ((this.currentPage * this.pageSize) < this.rowsTotal) this.currentPage++
    },
    prevPage: function () {
      if (this.currentPage > 1) this.currentPage--
    },
    select () {
      this.selected = []
      //   this.currentPage = 1
      if (!this.selectAll) {
        for (const i in this.filterData) {
          this.selected.push(this.filterData[i].id)
        }
      }
    },
    async refreshList () {
      this.$Progress.start()
      this.loader.isLoading = true
      var obj = {
        begin: this.date,
        end: this.date2,
        company_no: this.company_no,
        salesman: this.salesman_id,
        term: this.term,
        area: this.area,
        status: this.status,
        sale_type: this.includeTitipan
      }
      console.log(obj)
      console.log(salesUrl + '/report-outstanding-by-salesman-all')
      let salesArr = []
      let salesArr2 = []
      let salesmanArr = []
      await axios.post(salesUrl + '/report-outstanding-by-salesman-all', obj, { headers: getHeader(), timeout: 600000 })
        .then(response => {
          console.log(response.data.data)
          salesArr = response.data.data
          salesArr2 = response.data.saleColl
          salesmanArr = response.data.salesman
        })
        .catch(error => {
          this.$Progress.finish()
          this.loader.isLoading = false
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
      for (let s = 0; s < salesmanArr.length; s++) {
        const emp = this.employeeList.find(d => d.employee_no === salesmanArr[s].salesman_id)
        const areaColl = []
        for (let a = 0; a < this.areaList.length; a++) {
          const saleColl = []
          const saleColl2 = []
          let total = 0
          let totalPayment = 0
          let totalOutstanding = 0
          let totalOutstandingGiro = 0
          for (let d = 0; d < salesArr.length; d++) {
            if (salesArr[d].salesman_id === salesmanArr[s].salesman_id && this.areaList[a].name === salesArr[d].area) {
              saleColl.push(salesArr[d])
              total += salesArr[d].total
              totalPayment = salesArr[d].payment_balance
              totalOutstanding = salesArr[d].outstanding
              totalOutstandingGiro = salesArr[d].outstanding_giro
            }
          }
          for (let e = 0; e < salesArr2.length; e++) {
            if (salesArr2[e].salesman_id === salesmanArr[s].salesman_id && this.areaList[a].name === salesArr2[e].area) {
              saleColl2.push(salesArr2[e])
            }
          }
          if (saleColl.length > 0) {
            areaColl.push({
              name: this.areaList[a].name,
              total: total,
              total_payment: totalPayment,
              outstanding: totalOutstanding,
              outstanding_giro: totalOutstandingGiro,
              sale: saleColl,
              saleColl: saleColl2
            })
          }
        }
        const obj = {
          salesman_id: salesmanArr[s].salesman_id,
          salesman: emp ? emp.name : null,
          area: areaColl
        }
        this.dataRaw.push(obj)
      }
      await this.$Progress.finish()
      this.loader.isLoading = false
      // await this.refreshList2()
    },
    async refreshList2 () {
      this.rekapLoad = true
      const date = new Date(this.date2)
      const lastDay = new Date(date.getFullYear(), date.getMonth(), 0)
      const newlastDay = lastDay.getFullYear() + '-' + (lastDay.getMonth() + 1) + '-' + lastDay.getDate()
      this.dateRekap = new Date(newlastDay)
      var obj = {
        begin: this.date,
        end: newlastDay,
        company_no: this.company_no,
        salesman: this.salesman_id,
        term: this.term,
        area: this.area,
        status: this.status
      }
      // console.log(obj)
      // console.log(salesUrl + '/report-outstanding-by-salesman')
      await axios.post(salesUrl + '/report-outstanding-by-salesman', obj, { headers: getHeader() })
        .then(response => {
          this.dataRaw2 = response.data.data
          console.log(response.data.message)
          this.rekapLoad = false
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.rekapLoad = false
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
    }
  }
}
</script>

<style scoped>
.header-period {
  background-color: #6FB56F;
  color: white;
}
.text-ref-sales {
  color: #28A745;
  cursor: pointer;
}
</style>
